export default class EncryptModel {

	private $key = '6w9z$C&F)J@NcRfU';
	private $CryptoJS = require("crypto-js/core");

	private signInFormSelector: string = '#signInForm';
	private $passwordSelector: string = '#password';
	private $passwordActionFormSelector: string = '#passwordForm';
	private $passwordChnageFormSelector: string = '#changePasswordForm';
	private $encConfirmPasswordSelector: string = '#encConfirmPassword';
	private $encPasswordSelector: string = '#encPassword';
	private $confirmPasswordSelector: string = '#confirmPassword';
	private $currentPasswordSelector: string = '#currentPassword';
	private $encCurrentPasswordSelector: string = '#encCurrentPassword';

	private $form: JQuery<HTMLElement>;

	public constructor(formName: string) {
		this.encryptForm(formName);
	}

	private encryptForm(formName: string) {
		this.$form = $(formName);

		if (this.$form.valid()) {
			this.$CryptoJS.AES = require("crypto-js/aes");
			var key = this.$CryptoJS.enc.Utf8.parse(this.$key);
			var iv = key;

			var settings = {
				keySize: 128 / 8,
				iv: iv,
				mode: this.$CryptoJS.mode.CBC,
				padding: this.$CryptoJS.pad.Pkcs7
			};

			if (formName == this.signInFormSelector) {
				this.EncryptSignIn(key, settings);
			}

			if ([this.$passwordActionFormSelector, this.$passwordChnageFormSelector].indexOf(formName) > -1) {
				this.EncryptPassForms(key, settings);
			}
		}
	}

	private EncryptSignIn(key: any, settings: any) {
		var password = this.$form.find(this.$passwordSelector);
		var encPassword = this.$form.find(this.$encPasswordSelector);
		var passVal :any = password.val();
		
		if (typeof passVal !== 'undefined' && passVal) {
			var encryptedpassword = this.$CryptoJS.AES.encrypt(this.$CryptoJS.enc.Utf8.parse(passVal), key, settings);
			encPassword.val(encryptedpassword);
			password.val(this.$CryptoJS.lib.WordArray.random(32).toString().substring(0, passVal.length));
		}
	}

	private EncryptPassForms(key: any, settings: any) {

		var password = this.$form.find(this.$passwordSelector);
		var encPassword = this.$form.find(this.$encPasswordSelector);
		var confirmPassword = this.$form.find(this.$confirmPasswordSelector);
		var encConfirmPassword = this.$form.find(this.$encConfirmPasswordSelector);
		var passVal: any = password.val();
		var confirmVal: any= confirmPassword.val()

		if (typeof passVal !== 'undefined' && passVal
			&& typeof confirmVal !== 'undefined' && confirmVal) {

			var encryptedPass = this.$CryptoJS.AES.encrypt(this.$CryptoJS.enc.Utf8.parse(passVal), key, settings);
			encPassword.val(encryptedPass);
			password.val(this.$CryptoJS.lib.WordArray.random(32).toString().substring(0, passVal.length));

			encConfirmPassword.val(encryptedPass);
			confirmPassword.val(password.val());
			
			var currentPasssword = this.$form.find(this.$currentPasswordSelector);
			var currentVal: any = currentPasssword.val();
			if (typeof currentVal !== 'undefined' && currentVal) {
				var encCurrentPassword = this.$form.find(this.$encCurrentPasswordSelector);

				var encryptedCurrentPass = this.$CryptoJS.AES.encrypt(this.$CryptoJS.enc.Utf8.parse(currentVal), key, settings);
				encCurrentPassword.val(encryptedCurrentPass);
				currentPasssword.val(this.$CryptoJS.lib.WordArray.random(32).toString().substring(0, currentVal.length));			
			}
		}
	}
}



// WEBPACK FOOTER //
// ./Client/Scripts/models/encrypt.model.ts